import { useState } from "react";

export default function useFoodForm(initialData = {}) {
  const [formData, setFormData] = useState({
    image: "",
    foodName: "",
    description: "",
    category: "",
    subCategory: "",
    menuItemType: "Food",
    dietType: "Veg",
    price: "",
    offerPrice: "",
    preparationTime: "",
    quantity: "",
    unlimitedQuantity: false,
    isAvailable: true,
    availableToday: true,
    isBestSeller: false,
    isRecommended: false,
    availableFrom: "",
    availableTo: "",
    tags: [],

    ...initialData,
  });

  const updateField = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addTag = (tag) => {
    if (!tag.trim()) return;

    if (formData.tags.includes(tag)) return;

    setFormData((prev) => ({
      ...prev,
      tags: [...prev.tags, tag],
    }));
  };

  const removeTag = (tag) => {
    setFormData((prev) => ({
      ...prev,
      tags: prev.tags.filter((t) => t !== tag),
    }));
  };

  const resetForm = () => {
    setFormData({
      image: "",
      foodName: "",
      description: "",
      category: "",
      subCategory: "",
      menuItemType: "Food",
      dietType: "Veg",
      price: "",
      offerPrice: "",
      preparationTime: "",
      quantity: "",
      unlimitedQuantity: false,
      isAvailable: true,
      availableToday: true,
      isBestSeller: false,
      isRecommended: false,
      availableFrom: "",
      availableTo: "",
      tags: [],
    });
  };

  return {
    formData,
    updateField,
    addTag,
    removeTag,
    resetForm,
  };
}